import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ValidationService } from '../service/validation.service';
import { StatusTotals } from '../model/validation';
import { DcAlertService } from '@o3/ui-kit';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-summary-table',
  templateUrl: './summary-table.component.html',
  styleUrls: ['./summary-table.component.scss'],
})
export class SummaryTableComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  id;
  loading;
  columns;
  rows;
  dateRange: any;
  filteredRows: any;
  initialStatuses: StatusTotals;
  messages = {
    emptyMessage: 'No validations found.',
    totalMessage: 'Total',
  };
  sort = [
    {
      prop: 'createdDate',
      dir: 'desc',
    },
  ];
  selected = [];
  @Output() refId = new EventEmitter();
  constructor(
    private validationService: ValidationService,
    private dcAlertService: DcAlertService,
    private route: ActivatedRoute,
    private location: Location,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.columns = [
      {
        name: 'Date and time',
        prop: 'createdDate',
        resizeable: false,
        draggable: false,
        //minWidth: 160,
        canAutoResize: true,
        flexGrow: 1.5,
        cellTemplate: 'dateTimeTemplate',
      },
      {
        name: 'Ref',
        prop: 'uniqueId',
        resizeable: false,
        draggable: false,
        minWidth: 80,
        canAutoResize: true,
        flexGrow: 1.5,
      },
      {
        name: 'Status',
        prop: 'status',
        resizeable: false,
        draggable: false,
        width: 40,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'statusTemplate',
        cellClass: 'status-sm',
      },
    ];
    this.loading = true;
    this.subscriptions.add(
      this.route.params.subscribe((params) => {
        this.id = params['id'];
      })
    );

    this.fetchData();
    this.filterValueUpdate();
    this.listenForDownloadCsvRequests();
    // this.fetchDataApi();
  }

  // fetchDataApi() {
  //   this.validationService.get().subscribe(
  //     (rules) => {
  //       console.log(rules);
  //     },
  //     (error) => {
  //       console.log(error);
  //     },
  //     () => {}
  //   );
  // }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  fetchData() {
    this.subscriptions.add(
      this.validationService.getAllSummaryRules().subscribe(
        (rules) => {
          // console.log(rules);
          this.rows = rules;
          this.filteredRows = rules;
          this.initialStatuses = this.getStatusTotals(this.filteredRows);
          this.validationService.setStatusTotalsSubject(this.initialStatuses);
          this.loading = false;
          if (this.id !== undefined) {
            this.selectValidation();
          }
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.dcAlertService.showAlert({
            type: 'warning',
            message: error.message,
          });
        },
        () => {
          this.loading = false;
        }
      )
    );
  }

  selectValidation() {
    if (this.rows.length > 0) {
      let selectedReport;
      // this.id = '"0d564549-96d8-430d-b0c2-e06518bc4a2b".failed.json';
      selectedReport = this.rows.filter((x) => x.key == this.id)[0];
      if (selectedReport !== undefined) {
        this.selected.push(selectedReport);
        let obj = {
          type: 'click',
          row: {
            id: this.selected[0].id,
            key: this.selected[0].key,
            uniqueId: this.selected[0].uniqueId,
            createdDate: this.selected[0].createdDate,
            status: this.selected[0].status,
          },
        };
        this.tableActivate(obj);
      } else {
        this.dcAlertService.showAlert({
          type: 'warning',
          message: this.id + ' not found.',
        });
      }
    }
  }

  tableActivate(e) {
    if (e.type == 'click') {
      this.location.replaceState('/validation/' + e.row.key);
      this.titleService.setTitle(e.row.key + ' - Validation - InSPire Direct');
      const row = {
        id: e.row.id,
        key: e.row.key,
        ref: e.row.uniqueId,
        createdDate: e.row.createdDate,
        status: e.row.status,
      };
      this.titleService.setTitle(e.row.key + ' - Validation - InSPire Direct');
      this.refId.emit(row);
    }
  }

  filterValueUpdate(): void {
    this.subscriptions.add(
      this.validationService.listenForFilterValue().subscribe((filterValue) => {
        this.filterDataBySearchTerm(filterValue);
      })
    );
  }

  filterDataBySearchTerm(filterValue: any): void {
    this.dateRange = filterValue?.dateRange;
    const dateRange = filterValue?.dateRange
      ? filterValue?.dateRange
      : undefined;
    const searchText = filterValue?.searchText ? filterValue?.searchText : '';
    if (
      (searchText === undefined || searchText === '') &&
      (dateRange === undefined || dateRange === null)
    ) {
      this.filteredRows = this.rows;
      if (this.initialStatuses) {
        this.validationService.setStatusTotalsSubject(this.initialStatuses);
      }
      return;
    }
    const columnProps = this.columns.map((column) => column.prop);
    this.filteredRows = this.rows.filter((currentRow) => {
      return columnProps
        .map((columnProp) => {
          if (currentRow[columnProp]) {
            if (dateRange !== undefined) {
              const { from, to } = dateRange;
              const dateCreated = currentRow['createdDate'].split('T')[0];
              if (from && to) {
                return (
                  dateCreated >= from &&
                  dateCreated <= to &&
                  currentRow['uniqueId']
                    .toLowerCase()
                    .includes(searchText.toLowerCase())
                );
              } else if (from) {
                return (
                  dateCreated >= from &&
                  currentRow['uniqueId']
                    .toLowerCase()
                    .includes(searchText.toLowerCase())
                );
              } else return false;
            } else {
              return currentRow['uniqueId']
                .toLowerCase()
                .includes(searchText.toLowerCase());
            }
          } else {
            return false;
          }
        })
        .reduce((previous, current) => previous || current);
    });
    const statusTotalsForFilteredRows = this.getStatusTotals(this.filteredRows);
    this.validationService.setStatusTotalsSubject(statusTotalsForFilteredRows);
  }

  getStatusTotals(data: any[]): StatusTotals {
    const countFail = data.filter(
      (item) => item.status.toLowerCase() === 'failed'
    ).length;
    const countPass = data.filter(
      (item) => item.status.toLowerCase() === 'passed'
    ).length;

    return {
      pass: countPass,
      fail: countFail,
    };
  }

  listenForDownloadCsvRequests(): void {
    this.subscriptions.add(
      this.validationService.csvDownloadObservable$.subscribe((value) => {
        if (value === 'downloadCsvRequest') {
          const csvData: any[] = [];
          const length = this.filteredRows.length;
          const keys = this.filteredRows.map((el) => el.key);
          let validationForDownloadString = keys.join(',');
          this.validationService
            .getValidationResultsForCsv(this.dateRange)
            .subscribe((result) => {
              if (result.length) {
                this.validationService.setDownloadCsvSubject(result);
              }
            });
          // this.filteredRows.forEach((row) => {
          //   this.validationService.getRuleByKey(row).subscribe((result) => {
          //     csvData.push(result);
          //     if (csvData.length === this.filteredRows.length) {
          //       const csvDataOrdered = csvData.sort((a, b) =>
          //         a['id'] > b['id'] ? 1 : -1
          //       );
          //       this.validationService.setDownloadCsvSubject(csvDataOrdered);
          //     }
          //   });
          // });
        }
      })
    );
  }
}
